/**
 * Created by glopez on 19/04/17.
 */
// Action types
const ActionTypes = {
        SET_MODAL_SHOW: 'SET_MODAL_SHOW',
        SET_MODAL_HIDE: 'SET_MODAL_HIDE',
        SET_MODAL_TYPE: 'SET_MODAL_TYPE',
        SET_MODAL_STATUS: 'SET_MODAL_STATUS',
        SET_BEFORE_CLOSE: 'SET_BEFORE_CLOSE',
        SET_AFTER_CLOSE: 'SET_AFTER_CLOSE'
    },

    // Modal types
    ModalTypes = {
        LOGIN: 'LOGIN',
        CONFIRM: 'CONFIRM',
        DIALOG: 'DIALOG',
        SET_REMINDER: 'SET_REMINDER',
        FORGOT_PASSWORD: 'FORGOT_PASSWORD',
        RESET_PASSWORD: 'RESET_PASSWORD',
        REGISTER: 'REGISTER',
        CHANGE_PASSWORD: 'CHANGE_PASSWORD',
        PASSWORD_CHANGED: 'PASSWORD_CHANGED',
        SETTINGS_EDIT_NAME_EMAIL: 'SETTINGS_EDIT_NAME_EMAIL',
        SETTINGS_EDIT_ADDRESS_PHONE: 'SETTINGS_EDIT_ADDRESS_PHONE',
        HELP_REGISTER: 'HELP_REGISTER',
        T_C: "TERMS_AND_CONDITIONS",
        P_P: "PRIVACY_POLICY",
        CANCELATION_SURVEY: "CANCELATION_SURVEY",
        CRITICAL_INFORMATION: "CRITICAL_INFORMATION",
        PROMOTION_POPUP:"PROMOTION_POPUP",
        ERROR:"ERROR"
    },

    // Status values
    ModalStatus = {
        SHOW: 'SHOW',
        LOADING: 'LOADING',
        HIDE: 'HIDE',
        ERROR: 'ERROR'
    };

/**
 * Sets the before close method.
 *
 * @param {Function} method - Method to be executed before closing the modal.
 * @returns {Object} Action object.
 */
function setBeforeClose (method = null) {

    return {
        type: ActionTypes.SET_BEFORE_CLOSE,
        method: method
    };
}

/**
 * Sets the after close method.
 *
 * @param {Function} method - Method to be executed after closing the modal.
 * @returns {Object} Action object.
 */
function setAfterClose (method = null) {

    return {
        type: ActionTypes.SET_AFTER_CLOSE,
        method: method
    };
}

/**
 * Creates and returns a show modal action.
 *
 * @returns {Object} Show modal action.
 */
function showModal () {

    return {
        type: ActionTypes.SET_MODAL_SHOW,
        data: true
    };
}

/**
 * Creates and returns a hide modal action.
 *
 * @returns {Object} Hide modal action.
 */
function hideModal () {

    return {
        type: ActionTypes.SET_MODAL_HIDE,
        data: false
    };
}

/**
 * Creates and returns a set modal type action.
 *
 * @param {string} modalType - Modal type.
 * @returns {Object} Set modal type action.
 */
function setModalType (modalType) {

    return {
        type: ActionTypes.SET_MODAL_TYPE,
        data: modalType
    };
}

/**
 * Creates and returns a set status action.
 *
 * @param {string} status - Modal status.
 * @returns {Object} Set status action.
 */
function setStatus (status = ModalStatus.SHOW) {

    return {
        type: ActionTypes.SET_MODAL_STATUS,
        data: status
    };
}

export {
    showModal,
    hideModal,
    setModalType,
    setStatus,
    setBeforeClose,
    setAfterClose,
    ActionTypes,
    ModalTypes,
    ModalStatus
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modal.js